
import React, { useState } from 'react';
import NewLeadsHistogram from 'components/dashboard/NewLeadsHistogram';
import EmailsHistogram from 'components/dashboard/TokenUsageHistogram';
import { Row, Col } from "reactstrap";
import { faCalendar, faClipboardCheck, faList} from '@fortawesome/free-solid-svg-icons';
import { OBJ } from 'constants';
import { useTranslation } from 'react-i18next';
import PieChart from 'components/dashboard/PieChart';
import { API_ENDPOINTS } from 'constants';
import { useFetchData } from 'hooks/apiHooks';
import ApiError from 'components/common/ApiError';

const viewOptions = [
    { id: OBJ.TODOS_KANBAN, label: 'button.kanban', icon: faClipboardCheck},
    { id: OBJ.TODOS, label: 'button.list', icon: faList},
    { id: OBJ.TODOS_CALENDAR, label: 'button.calendar', icon: faCalendar},
];

function Dashboard(props) {
    const { t } = useTranslation();
    const [isMaximized, setIsMaximized] = useState(false);
    const { data , isLoading, error, refetch } = useFetchData(API_ENDPOINTS.REPORTS.ELEVENLABS)
    const {elevenlabs_token, elevenlabs_voices, totals} = data || {}

    const toggleMaximize = () => {
        setIsMaximized(!isMaximized);
    };

    if (error) return <ApiError retryFetch={refetch} errorMessage={error.message}/>    
    return (
        <div className="content">
            <Row>
                <Col lg={isMaximized ? "12" : "6"}>
                    <NewLeadsHistogram toggleMaximize={toggleMaximize}/>
                </Col>
                <Col lg={isMaximized ? "12" : "6"}>
                    <EmailsHistogram isMaximized={isMaximized} toggleMaximize={toggleMaximize} />
                </Col> 

                <Col md="3">
                    <PieChart 
                        title={t('reports.title.ElevenLabsTokenUsage')}
                        icon='icon-chat-33'
                        total={totals?.usage}
                        colorScheme='blue'
                        input={elevenlabs_token}
                    />
                </Col>
                <Col md="3">
                    <PieChart 
                        title={t('reports.title.ElevenLabsVoiceUsage')}
                        icon='icon-volume-98'
                        total={totals?.voices}
                        colorScheme='blue'
                        input={elevenlabs_voices}
                    />
                </Col>
                {!isLoading && data.map((report, idx) => (
                <React.Fragment key={idx}>
                    <Col md="12">
                        <h5 style={{ marginTop: '1rem' }}>{report.chat}</h5>
                    </Col>
                    <Col md="3">
                        <PieChart 
                            title={t('reports.title.ElevenLabsTokenUsage')}
                            icon='icon-chat-33'
                            total={report.totals?.usage}
                            colorScheme='blue'
                            input={report.elevenlabs_token}
                        />
                    </Col>
                    <Col md="3">
                        <PieChart 
                            title={t('reports.title.ElevenLabsVoiceUsage')}
                            icon='icon-volume-98'
                            total={report.totals?.voices}
                            colorScheme='blue'
                            input={report.elevenlabs_voices}
                        />
                    </Col>
                </React.Fragment>
            ))}
            </Row>
        </div>
    );
}

export default Dashboard;
